module.exports = __webpack_public_path__ + "static/img/zj04.7e790ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj04.png
// module id = 141
// module chunks = 0